import { Form, InputNumber } from 'antd';

import { useMemoState } from 'hooks';
import { getFormattedPercent } from 'utils';

import { TFieldProps } from 'types';

import { handleChange } from './formInputPercentHelpers';

const { Item } = Form;

interface IInputCurrencyProps extends Omit<TFieldProps, 'type' | 'name' | 'value' | 'onChange'> {
  value?: string;
  onChange?: (value: number | null) => void;
}

export const InputPercent = ({
  max = 100,
  min = 0.01,
  step = 0.01,
  value,
  disabled,
  precision = 2,
  inputStyles,
  placeholder,
  onChange,
}: IInputCurrencyProps) => {
  const [percent, setPercent] = useMemoState<number | null>(Number(value) * 100);

  return (
    <InputNumber
      min={min as number}
      max={max as number}
      step={step}
      value={percent}
      className='w-full'
      style={inputStyles}
      disabled={disabled}
      precision={precision}
      placeholder={placeholder}
      onChange={handleChange(setPercent, onChange)}
      formatter={getFormattedPercent}
    />
  );
};

export const FormInputPercent = ({
  min,
  max,
  step,
  name,
  label,
  rules,
  tooltip,
  disabled,
  precision,
  placeholder,
  inputStyles,
  dependencies,
  itemClassName,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
    dependencies={dependencies}
  >
    <InputPercent
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      precision={precision}
      inputStyles={inputStyles}
      placeholder={placeholder}
    />
  </Item>
);
